import { lazy } from 'react'

const routes = [
  {
    path: '/',
    component: lazy(() => import('../pages/home'))
  },
  {
    path: '/register',
    component: lazy(() => import('../pages/register'))
  },
  {
    path: '/register/detail/:id',
    component: lazy(() => import('../pages/register/Detail'))
  },
  {
    path: '/healthy-report',
    component: lazy(() => import('../pages/healthy-report'))
  },
  {
    path: '/user',
    component: lazy(() => import('../pages/user'))
  },
  {
    path: '/secretary',
    component: lazy(() => import('../pages/user/Secretary'))
  },
  {
    path: '/account',
    component: lazy(() => import('../pages/account'))
  }
]

export default routes
